import { partnersApi } from 'api';
import { FeatureEligibility } from 'pco-product-service-internal-consumer';

export const getIsPartnerEligible = async (partnerNumber: string): Promise<FeatureEligibility[]> => {
  const response = await partnersApi.isPartnerEligible({ partnerUid: partnerNumber });
  return response.features ?? [];
};
